<!-- <template>
  <LoginForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import LoginForm from "../../components/Authentication/Login/LoginForm.vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    LoginForm,
  },
});
</script> -->

<template>
  <AuthentificationForm/>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthentificationForm from "@/components/Authentication/Login/AuthentificationForm.vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    AuthentificationForm
  },
});
</script>